import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';
import { Button as Buttons } from '@telus-uds/components-web'
import ConfirmationBox from '../../design/shared/ConfirmationBox';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { orderDetailsForm } from '../../utils/constant';
import { Button,ButtonBox } from './css';

const ModifyQuote = ({ orderData, status }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: {
      confirmationDialog,
      modifyQuote,
      continueLabel,
      modifyOrder,
      modifyConfirmation
    },
    formButtons: { confirmButtonLabel, cancelButtonLabel }
  } = localizedStrings;
  const { locale, categoryName, id, isQuoteReference } = orderData;
  const history = useHistory();

  const getLabel = () => {
    let label;
    switch (status) {
      case 'incomplete':
        label = continueLabel;
        break;
      case 'waitingOnSales':
        label = modifyOrder;
        break;
      default:
        label = modifyQuote;
    }
    return label;
  };

  const handleModifyQuote = () => {
    history.push({
      pathname: `/${locale}/${categoryName}/${orderDetailsForm}`,
      search: `?orderId=${id}&step=1`
    });
    window.location.reload();
  };

  if (isQuoteReference) return null;

  return (
    <>
      <Button className="action-button" onClick={() => setIsModalOpen(true)}>
        {getLabel()}
      </Button>
      <ConfirmationBox
        open={isModalOpen}
        hideCloseButton={!isModalOpen}
        setOpen={() => isModalOpen}
        header={confirmationDialog}
        onClose={() => setIsModalOpen(false)}
      >
        <p style={{ fontSize: '15px', padding: '8px 0' }}>{modifyConfirmation}</p>
        <ButtonBox>
          <Buttons variant={{ priority: 'high' }} onPress={handleModifyQuote} >Confirm</Buttons>
          <Buttons variant={{ priority: 'low' }} onPress={() => setIsModalOpen(false)}>cancel</Buttons>
        </ButtonBox>
      </ConfirmationBox> 
    </>
  );
};

ModifyQuote.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  status: PropTypes.string.isRequired
};

export default ModifyQuote;
